<div class="button-bar">
    <clx-button type="icon" title="Refresh" i18n-title="@@webaccess.button.refresh" class="small icon fa-refresh fa io" (onClick)="refresh()"></clx-button>
    <clx-button type="icon" title="Open in new tab" i18n-title="@@webaccess.button.openinnewtab" class="small icon fa-external-link fa io" (onClick)="openInNewTab()"></clx-button>
</div>
<iframe [attr.src]="launchWebAccessUrl" style="width: 100%; height: 620px; border: 0 none"></iframe>